import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import CSSModules from 'react-css-modules';
import styles from './slide.scss';

const Slide = ({ objId, media, isActive, activeSlide }) => (
    <Link
        styleName="slide"
        className={isActive ? 'is-active' : ''}
        style={{backgroundImage: `url(${media.MulOverlayImageUrl})`}}
        to={{ pathname: `/overlay/${objId}`, query: { activeSlide: activeSlide } }}
    />
);

Slide.propTypes = {
    objId: PropTypes.string.isRequired,
    media: PropTypes.object,
    isOverlay: PropTypes.bool.isRequired,
    isActive: PropTypes.bool.isRequired,
    activeSlide: PropTypes.number.isRequired,
};

export default CSSModules(Slide, styles);


// WEBPACK FOOTER //
// ./app/components/Object/Slider/Slide/Slide.jsx